export const Marquee = ({ items }) => {
  const row = [...items, ...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 py-6" data-testid="marquee-section">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className={`font-display text-2xl font-semibold uppercase tracking-tight md:text-3xl ${i % 2 ? "text-outline" : "text-slate-600"}`}>
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#00e5ff]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
